<template>
  <div id="container" :class="{'newYear':isBGLogin}">
    <div id="LoginBox">
      <router-link class="el-icon-arrow-left back" :to="{path:'/login'}">{{$t('base.back')}}</router-link>
      <div class="login_logo set_h1">
        <h1>{{$t('base.resetPassword')}}</h1>
      </div>
      <el-form class="register_box set_box" :model="ruleForm" :rules="rules" ref="setword">
        <el-form-item class="login_form_item" prop="email">
          <!-- 国籍 -->
          <div class="locationPhoneBox login_location" v-if="type=='1'">
            <div class="countries" v-if="location.MemberSource!=''">
              <img :src="location.LocationIcon" alt="">
            </div>
            <el-select class="login_ipt" :class="location.MemberSource!=''?'nolocation':''" placeholder="" v-model="location.MemberSource" popper-class='location' @change='changeLocation'>
              <el-option class="locationelOption" :label="item.EnName" :value="item.Code" v-for="(item,index) in locationOption" :key='index'>
                <div class="locationOption">
                  <img :src="item.IconUrl">
                  <span>{{item.EnName}}</span>
                </div>
              </el-option>
            </el-select>
            <div class="nationCode">
              {{location.AreaCode}}
            </div>
          </div>
          <el-input class="login_ipt first_login_ipt" :class="{'email':type=='1'}" @focus="smsMsg=''" v-model="ruleForm.email" :placeholder="type=='1'?$t('base.phoneNumber'):$t('rules.enterEmali')"></el-input>
        </el-form-item>
        <div class="code_box">
          <el-form-item class="login_form_item" prop="code">
            <el-input class="login_ipt" v-model="ruleForm.code" minlength='6' maxlength='6' :placeholder="$t('rules.enterCode')"></el-input>
          </el-form-item>
          <div class="code text_blue" v-if="isCode" @click="ruleForm.email.length>0?getCode('setword'):''" :class="ruleForm.email.length<=0?'noemail':''"><span>{{$t('base.verify')}}</span></div>
          <div class="code Resend" v-if="!isCode"><span>{{$t('base.resendIn')}} {{ times }}s</span></div>
        </div>
        <el-form-item class="login_form_item" prop="password">
          <el-input class="login_ipt" :type="flagType" v-model="ruleForm.password" :placeholder="$t('base.enterPassword')" autocomplete="new-password" minlength='6' maxlength='20' @input="forbidInput('password')">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" v-show="ifshow" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <!-- <el-form-item class="login_form_item" prop="password">
          <el-input class="login_ipt" type="password" show-password minlength='6' maxlength='20' v-model="ruleForm.password" placeholder="Enter password"></el-input>
        </el-form-item> -->
        <div class="forgot">
          {{$t('alert.pwdTip')}}
        </div>
        <div class="show_check_email">
          <!-- <div class="check_email" v-if="checkEmail">Check your email! A 6-digit code was sent to {{ruleForm.email}}.</div> -->
        </div>
        <el-button class="text_btn" type="primary" :disabled="disabled" @click="submitForm('setword')">{{$t('base.next')}}</el-button>
      </el-form>
      <div class="terms_checked">
        <!-- <el-checkbox v-model="checked"></el-checkbox> -->
        <!-- <el-checkbox  v-model="checkbox " :label="1">{{radioNumber}}</el-checkbox >
        <div>
          I have read and accpted the <router-link class="text_blue" :to="{path:'/terms/privacy?type=2'}" target="_blank">Terms of Service</router-link> and <router-link class="text_blue" :to="{path:'/terms/privacy?type=1'}" target="_blank">Privacy Policy</router-link>
        </div> -->
      </div>
      <div class="account_box">
        {{$t('symbol.noAccount')}} <router-link class="text_blue" :to="{path:'/register'}">{{$t('base.signUp')}}</router-link>
      </div>
      <div class="isIframe" v-if="isIframe">
        <span class="closeSpan" @click="isIframe=false">X</span>
        <iframe id="ifcheckbox" :src="url" name="check" class="check_box" scrolling="no"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { CensoredEmail, getUser, isEmoji } from "@/api/public";
export default {
  name: 'index',
  components: {},
  data() {
    // var email = () => {
    //   let str = this.$route.query.email;
    //   str = str.split('@');
    //   if (str[0].length <= 3) {
    //     str[0] = str[0].substr(0, 1)
    //   } else {
    //     str[0] = str[0].substr(0, 3)
    //   }
    //   return str[0] + "*********@" + str[1]
    // };
    /**
     * 验证用户输入的邮箱或手机号格式
     * @param {Object} rule 验证规则对象
     * @param {string} value 需要验证的值
     * @param {Function} callback 回调函数
     * 
     * 验证规则:
     * - 邮箱格式: 标准邮箱格式验证
     * - 手机号格式:
     *   - 香港/澳门: 8位数字
     *   - 美国/台湾: 10位数字(台湾第二位必须为9)
     *   - 其他地区: 至少6位数字
     */
    var userValidate = (rule, value, callback) => {
      var msg = this.$t('rules.invalidPhone')
      if (this.smsMsg) {
        msg = this.smsMsg
        this.smsMsg = ""
        callback(new Error(msg));
      } else if (value === '') {
        if (this.type == '0') {
          msg = this.$t('rules.invalidEmailAgain')
        }
        callback(new Error(msg));
      } else if (value != '') {
        // 验证 美国，香港，澳门，台湾 手机号位数 香港，澳门 为8位，美国，台湾为10位，台湾第二位必定是9
        if (this.type == '0') {
          let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (reg.test(value)) {
            callback();
          } else {
            callback(new Error(this.$t('rules.invalidEmailAgain')));
          }
        } else {
        let reg = /^\d{6,}$/;
          if (this.location.MemberSource == 'HK' || this.location.MemberSource == 'MO') {
            // 香港 澳门
            reg = /^\d{8}$/;
          }
        if (this.location.MemberSource == 'US' || this.location.MemberSource == 'TWN'||this.location.MemberSource == 'TW') {
          // 美国 台湾
          reg = /^\d{10}$/;
        }
          if (reg.test(value)) {
            // 台湾
            if (this.location.MemberSource == 'TWN'||this.location.MemberSource == 'TW') {
              if (value.substring(1, 2) != '9') {
                callback(new Error(msg));
              }
              callback();
            }
            callback();
          } else {
            callback(new Error(msg));
          }
        }
      } else {
        callback();
      }
    };
    /**
     * 验证输入值长度是否大于等于6位的校验函数
     * @param {Object} rule 校验规则对象
     * @param {string} value 需要校验的值
     * @param {Function} callback 回调函数,校验不通过时传入 Error 对象
     */
    var numSix = (rule, value, callback) => {
      if (value.length > 0 && value.length < 6) {
        callback(new Error(this.$t('rules.pwdCharacterRule')));
      } else {
        callback();
      }
    };
    return {
      // checkEmail: false,
      // checked: false,
      isBGLogin:process.env.VUE_APP_LOGIN,
      checkUrl: process.env.VUE_APP_CMS + '/checkcode/index?mobile=', // 图片验证
      url:'',
      isIframe: false, // 图片验证
      loading: false,
      type: '', //登录类型 0邮箱 1手机号
      times: 120,
      disabled: false,
      isCode: true,
      radioNumber: '',
      checkbox: true,
      flagType: 'password',
      flag: false,
      ifshow: false,
      locationOption: '',
      location: {
        MemberSource: '',
        LocationIcon: '',
        LocationName: '',
        AreaCode: ''
      },
      ruleForm: {
        email: '',
        code: '',
        password: '',
      },
      rules: {
        email: [
          //{ required: true, message: 'Invalid email. Please check and try again.', trigger: 'blur' },
          //{ type: 'email', message: 'Invalid email. Please check and try again.', trigger: 'blur' },
          { validator: userValidate, trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$t('rules.invalidCodeAgain'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('rules.pwdCharacterRule'), trigger: 'blur' },
          { validator: numSix, trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/, message: this.$t('rules.pwdRule'), trigger: 'blur' },
          //{ pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{6,20}$/, message: 'Password should contain at least 1 uppercase letter and 1 number',trigger: 'blur'},
        ]
      }
    }
  },
  created() {
    let str = this.$route.query.account;
    let type = this.$route.query.type;
    if (str != null) {
      this.ruleForm.email = str
    }
    if (type != null) {
      this.type = type
    }
    if (this.$route.query.source) {
      this.location.MemberSource = this.$route.query.source
    }
    this.getNationIcons()
  },
  mounted() {
    let that = this
    window.addEventListener("message", function(e) {
      //console.log(e)
      if (e.data == "checkcode") {
        that.getCodeOk()
        //console.log(e)
      }
    });
    // /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{8,}$/
  },
  destroyed(){
    this.removeListener()
  },
  beforeDestroy() {
    this.removeListener()
    //window.removeEventListener('message', function(e) {});
  },
  methods:{
    // 修改国家
    changeLocation(e) {
      let that = this
      that.locationOption.map(res => {
        if (res.Code == e) {
          that.location.MemberSource = res.Code //
          that.location.LocationIcon = res.IconUrl
          that.location.LocationName = res.EnName
          that.location.AreaCode = res.NationCode
        }
      })
    },
    //获取全部国家图标地址
    getNationIcons() {
      let that = this
      if (that.type == 1) {
        this.$get(this.$interface.GetAllNationIcons, '').then(res => {
          if (res.Result != 0) {
            that.locationOption = res.Data
            res.Data.map(item => {
              if (item.Code == this.location.MemberSource) {
                that.location.MemberSource = item.Code
                that.location.LocationIcon = item.IconUrl
                that.location.LocationName = item.EnName
                that.location.AreaCode = item.NationCode
              }
            })
            // that.location.MemberSource = res.Data[0].Code //
            // that.location.LocationIcon = res.Data[0].IconUrl
            // that.location.LocationName = res.Data[0].EnName
            // that.location.AreaCode = res.Data[0].NationCode
          }
        })
      }
    },
    forbidInput(e) {
      let num = 1
      this.ruleForm[e] = isEmoji(this.ruleForm[e], num)
      //是否显示查看密码的图标
      if (this.ruleForm.password.length > 0) {
        this.ifshow = true
      } else {
        this.ifshow = false
      }
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      // console.log(this.flag,this.flagType)
    },
    // 获取验证码
    getCode(formName) {
      let that = this;
      that.smsMsg = ""
      // 获取验证码
      // let getCodeOk = () => {
      //   that.isCode = false;
      //   that.timer = setInterval(() => {
      //     that.times--;
      //     if (that.times === 0) {
      //       that.times = 120;
      //       that.isCode = true;
      //       clearInterval(that.timer)
      //     }
      //   }, 1000)
      //   var data = { 'email': that.ruleForm.email, "type": 1 }
      //   var url = that.$interface.GetCodeEmail
      //   if (that.type == 1) {
      //     // 获取手机验证码
      //     data = { 'TelPhone': that.ruleForm.email, 'Type': 1, 'NationCode': that.location.AreaCode }
      //     url = that.$interface.GetCode
      //   }
      //   this.$post(url, data).then(res => {
      //     console.log(res)
      //     if (res.Result != 0) {
      //       that.disabled = false;
      //       // that.checkEmail = true;

      //     } else {
      //       that.times = 120;
      //       clearInterval(that.timer)
      //       that.smsMsg = "Sending an email failed!"
      //       that.$refs[formName].validateField("email");
      //       that.isCode = true;
      //       //that.$message.error(res.Msg);
      //     }
      //   })
      // }

      // 删除监听
      // let removeListener = () => {
      //   that.isIframe = false;
      //   window.removeEventListener('message', function(e) {});
      // }
      this.$refs[formName].validateField('email', (val) => {
        if (val == "") {
          if (that.type == 1) {
            // 手机获取验证码
            that.url=that.checkUrl+that.ruleForm.email+'&lang=en';
            that.isIframe = true;
            // 开始监听
            // window.addEventListener("message", function(e) {
            //   getCodeOk()
            //   removeListener()
            // });
          } else {
            // 邮箱获取验证码
            this.getCodeOk()
          }
        }
      });
    },
    getCodeOk() {
      let that = this;
      that.smsMsg = ""

      that.isIframe = false;
      that.isCode = false;
      that.timer = setInterval(() => {
        that.times--;
        if (that.times === 0) {
          that.times = 120;
          that.isCode = true;
          clearInterval(that.timer)
        }
      }, 1000)
      // 获取邮箱验证码
      var data = { 'email': that.ruleForm.email, "type": 1 }
      var url = that.$interface.GetCodeEmail
      if (that.type == 1) {
        // 获取手机验证码
        data = { 'TelPhone': that.ruleForm.email, 'Type': 1, 'NationCode': that.location.AreaCode }
        url = that.$interface.GetCode
      }
      this.$post(url, data).then(res => {
        //console.log(res)
        if (res.Result != 0) {
          that.disabled = false;
          // that.checkEmail = true;

        } else {
          that.times = 120;
          clearInterval(that.timer)
          that.smsMsg = res.Msg
          that.$refs['setword'].validateField("email");
          that.isCode = true;
          //that.$message.error(res.Msg);
        }
      })
    },
    // 修改密码
    submitForm(formName) {
      var that = this;
      that.smsMsg = "";
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 邮箱修改密码
          var data = { 'email': this.ruleForm.email, 'newPassword': this.ruleForm.password, 'code': this.ruleForm.code }
          var url = this.$interface.ResetPassword
          if (that.type == 1) {
            // 手机修改密码
            data = { 'TelPhone': that.ruleForm.email, 'Code': this.ruleForm.code, 'NewPassword': this.ruleForm.password, 'AreaCode': that.location.AreaCode }
            url = that.$interface.ResetPasswordPhone
          }
          if (this.checkbox == false) {
            this.$alert(this.$t('alert.serviceAPrivacy'), this.$t('base.notice'), { showConfirmButton: false });
          } else {
            this.disabled = true;
            that.loading = true;
            this.$post(url, data).then(res => {
             // console.log(res)
              if (res.Result != 0) {
                //window.localStorage.setItem("cardUser",JSON.stringify(res.Data))
                that.$message({
                  message: this.$t('alert.resetPwd'),
                  duration: 1000,
                  type: 'success'
                });
                that.$router.push({ path: '/login' })
                //res.Data.Email = CensoredEmail(this.$route.query.email)
                //let result = res.Data
                //setTimeout(function() { getUser(result) }, 1000)
              } else {
               // console.log(res.Msg)
                that.$message.error(res.Msg);
                that.loading = false;
              }

              that.disabled = false;
            }).catch(error => {
              that.loading = false;
              that.disabled = false;
            })
          }
        }
      });
    },
    removeListener() {
      // 删除监听
      this.isIframe = false;
      window.removeEventListener('message', function(e) {});

    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";

.terms_checked {
  display: flex;
  margin: 24px 0 0;
}

</style>



// WEBPACK FOOTER //
// src/pages/shared/forgot.vue